import { ChangeDetectionStrategy, Component, input, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CtDocument } from '../../model/ct-batch-model';

@Component({
  selector: 'ct-shared-page-preview-separator',
  imports: [CommonModule],
  templateUrl: './page-preview-separator.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PagePreviewSeparatorComponent {
  readonly document = input.required<CtDocument>();
  readonly splitIndex = input.required<number>();

  readonly pageSeparatorLabelTemplate =
    input<TemplateRef<{ $implicit: CtDocument; splitIndex: number }>>();
}
